export abstract class Serializable<T> {
	abstract deserialize(input: Object): T;
	serialize(){
		return JSON.stringify(this, (key, value) => {
			if (!(typeof value == 'boolean') && (value == '' || value == [''])) {
				return undefined;
			}
			return value;
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/main/shared/models/serializable.ts